import { render, staticRenderFns } from "./dianpuzhuanxiu.vue?vue&type=template&id=4016b887&"
import script from "./dianpuzhuanxiu.vue?vue&type=script&lang=js&"
export * from "./dianpuzhuanxiu.vue?vue&type=script&lang=js&"
import style0 from "./dianpuzhuanxiu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports